import { FC } from 'react';

import { getPurpurIcon } from '@telialt/common-icon/src/utils';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';

import { getIsLinkActive } from '../../utils/path';
import { MenuItemIcon, StyledMenuItem } from './MenuItem.styles';

interface Props {
    item: NavigationItem;
}

export const MenuItemLink: FC<Props> = ({ item }) => {
    const { title, url, colorOption, displayOption, icon } = item;
    const pathname = usePathname();
    const isActive = url ? getIsLinkActive(url, pathname) : false;
    const purpurIcon = getPurpurIcon(icon);

    return (
        <StyledMenuItem
            $displayOption={displayOption}
            $isActive={isActive}
            aria-current={isActive ? 'page' : undefined}
            $colorOption={colorOption}
            href={url}
            data-element="Link"
            data-element-name={title}
            data-element-color-option={colorOption}
        >
            {title}
            {purpurIcon && <MenuItemIcon svg={purpurIcon} size="sm" />}
        </StyledMenuItem>
    );
};
